import { createSlice } from "@reduxjs/toolkit";

const actionsSlice = createSlice({
  name: "actionsSlice",
  initialState: {
    actions: [],
  },
  reducers: {
    addAction(state, { payload }) {
      state.actions.unshift(payload);
    },

    delAction(state, { payload }) {
      const delId = payload;
      state.actions = state.actions.filter((action) => action.id !== delId);
    },

    setActions(state, { payload }) {
      state.actions = payload;
    },
  },
});

export default actionsSlice.reducer;

export const { addAction, delAction, setActions } = actionsSlice.actions;
